<template>
    <div class="max-w-[1700px] mx-auto mt-10 mx-auto flex w-full text-center justify-center">
        <h2 class="font-['Anton'] leading-[0.85] text-[#f8f1e7]">
          <LogoComponent :customClass="'text-4xl md:text-6xl'" />
        </h2>

      </div>
</template>

<script setup>
import LogoComponent from '@/components/LogoComponent.vue';

</script>